import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapLayoutComponent } from '../map-layout.component';
import { MapHistoryComponent } from '../../map-history/map-history.component';
import { MapHeaderComponent } from '../map-header/map-header.component';
import { MapSidebarComponent } from '../map-sidebar/map-sidebar.component';
import { MapMainComponent } from './map-main.component';
import { JobPopupComponent } from '../map-components/job-popup/job-popup.component';
import { EmployeePopupComponent } from '../map-components/employee-popup/employee-popup.component';
import { OrganizationPopupComponent } from '../map-components/organization-popup/organization-popup.component';
import { OriginDestinationPopupComponent } from '../map-components/origin-destination-popup/origin-destination-popup.component';
import { DrawPopupComponent } from '../map-components/draw-popup/draw-popup.component';
import { TerritoryPopupComponent } from '../map-components/territory-popup/territory-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/shared/shared.module';
import { PreviewDataModule } from 'app/components/preview-data/preview-data.module';
import { RouteFormModule } from 'app/components/route-form/route-form.module';
import { RouteDetailsModule } from 'app/components/route-details/route-details.module';
import { MapSettingsModule } from 'app/components/map-settings/map-settings.module';
import { NewJobModule } from 'app/components/new-job/new-job.module';
import { ViewHistoryModule } from 'app/components/view-history/view-history.module';
import { NoHistoryModule } from 'app/components/no-history/no-history.module';
@NgModule({
  declarations: [
    MapLayoutComponent,
    MapHistoryComponent,
    MapHeaderComponent,
    MapSidebarComponent,
    MapMainComponent,
    JobPopupComponent,
    EmployeePopupComponent,
    OrganizationPopupComponent,
    OriginDestinationPopupComponent,
    DrawPopupComponent,
    TerritoryPopupComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule,
    PreviewDataModule,
    RouteFormModule,
    RouteDetailsModule,
    MapSettingsModule,
    NewJobModule,
    ViewHistoryModule,
    NoHistoryModule,
  ],
  exports:[
    MapMainComponent
  ]
})
export class MainMapModule { }
